import { createContext, useContext } from 'react';

const RValueCalculatorContext = createContext();

export const useRValueCalculator = () => useContext(RValueCalculatorContext);

export default RValueCalculatorContext;
